// Parent area (/, /shop, /orders, /profile, /cart): guard, then the school header above a stack
// (FR-013, FR-014, FR-016; R-2, R-7; routes.md). Desktop chrome: the header spans every parent page.
// Phone chrome: the header belongs to the four tabs ((tabs)/_layout); a pushed screen slides in
// whole, with its own app bar (ScreenScaffold).
import { Stack } from "expo-router";
import { StyleSheet, View } from "react-native";

import { ParentDataSync } from "@/profile/ParentDataSync";
import { SchoolHeader } from "@/shell/header/SchoolHeader";
import { useChromeKind } from "@/shell/chrome/useChromeKind";
import { RouteGuard } from "@/shell/RouteGuard";
import { makeStyles } from "@/theme/makeStyles";

const useStyles = makeStyles((t) =>
  StyleSheet.create({
    area: { flex: 1, backgroundColor: t.color.background },
  }),
);

export default function ParentLayout() {
  const styles = useStyles();
  const desktop = useChromeKind() === "desktop";
  return (
    <RouteGuard area="parent">
      <View style={styles.area}>
        {/* 004 FR-046: the header follows the selected child's school. */}
        <ParentDataSync />
        {desktop ? <SchoolHeader /> : null}
        <Stack
          screenOptions={{
            headerShown: false,
            contentStyle: styles.area,
            // Phones: pushed screens slide in from the right, as Android screens do.
            animation: desktop ? "none" : "slide_from_right",
          }}
        />
      </View>
    </RouteGuard>
  );
}

// A screen that throws shows the themed fallback (FR-041; US6-2).
export { ErrorFallback as ErrorBoundary } from "@/shell/ErrorFallback";
